import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

import { firebaseConfig } from './installation';   // ruling 312: the installation's binding, one file

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// LOCAL persistence — stays signed in across browser/window closes (was SESSION, which forced re-login every close)
setPersistence(auth, browserLocalPersistence).catch(console.error);
